import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';
import * as $ from 'jquery'
import { TosterMsgType } from 'src/app/services/model';
import { Subject } from 'rxjs';
import { CleverTapConstents } from 'src/app/services/constants';
@Component({
  selector: 'app-aadhar-details',
  templateUrl: './aadhar-details.component.html',
  styleUrls: ['./aadhar-details.component.scss']
})
export class AadharDetailsComponent {
  aadhaarNo: string = '';
  requestId: string = '';
  defultTime: number = 40;
  resendTimer: number = this.defultTime;
  @Input() switchTabs:Subject<any> = new Subject();
  get timerCount() {
    return this.resendTimer.toString().padStart(2, '0');
  }
  resendClickTimes = 0;
  otpForm!: FormGroup;
  showPortal: boolean = false;
  isHideAadharFields = false;
  errMsg: string = '';
  openDigiLockerDialog: boolean = false;
  digiUrlDatas: any = {}
  popupWindow: any;
  interval: any;
  showLoader:boolean=false;

  get currentApplicant() {
    return this.util.loanDetails? { ...this.util.getCurrentApplicant}: {};
  }

  get isMoratorium():boolean{
    return this.util.loanDetails && (this.util.loanDetails.hasMoratorium || this.util.loanDetails.isCapacitaFlow) && !(!this.util.loanDetails.isStudentMainApplicant && !this.util.loanDetails.isSponser);
  }


  constructor(public util: UtilService) { }
  ngOnInit() {
   this.switchTabs.subscribe((res)=>{
    this.switchTab(res);
   });
   this.init();
   this.util.userLoggedInEventCalled.subscribe(()=>{
    this.init();
   });
  }

  init(){
    if(!this.util.loanDetails)
    return;
    this.util.setCache('kycTab', 'KYC');
    this.otpFormGroupLoad();

    const applicant = this.util.loanDetails.loanApplicantDetails?.find((applicant: any) => applicant.selfiNotComplete);
    if (applicant) {
      this.util.setCache('currentApplicant', applicant.id);
    }
    
  }

  // ngAfterViewInit() {
  //   window.addEventListener('message', (event) => {
  //     console.log(event.data.payload, event.data.status);
  //   })
  // }
  otpFormGroupLoad() {
    //   for (let i = 0; i < 2; i++) {
    this.otpForm = new FormGroup({
      field1: new FormControl(null, [Validators.required]),
      field2: new FormControl(null, [Validators.required]),
      field3: new FormControl(null, [Validators.required]),
      field4: new FormControl(null, [Validators.required]),
      field5: new FormControl(null, [Validators.required]),
      field6: new FormControl(null, [Validators.required]),
    });

    //     this.otpFormArray.push(formGroup);
    //   }

  }
  tabChange(val: any) {
    let ele: any = document.querySelectorAll('.otp-inputs input');
    let firstValue: any = $(".first-input").val();
    if (val == 1 && firstValue && firstValue.length > 6) {
      $('.otp-validate-section input').each((indexNo, inputBox) => {
        $(inputBox).val(firstValue[indexNo]);
      })
    } else {
      if (ele[val - 1].value != '') {
        ele[val - 1].value = ele[val - 1].value.substr((ele[val - 1].value).length - 1, 1);
        if (ele[val]) ele[val].focus();
      } else if (ele[val - 1].value == '') {
        if (ele[val - 2]) ele[val - 2].focus();
      }
    }
    if (this.otpForm.valid) {
      this.otpSubmit();
    }
  }

  timerRun() {
    this.resendTimer = this.defultTime;
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.resendTimer != 0) {
        this.decrementTimer()
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
  }
  decrementTimer() {
    this.resendTimer--;
  }
  reSend() {
    this.errMsg = '';
    this.otpForm.reset();
    document.querySelectorAll('.otp-inputs input').forEach((value: any) => {
      value.value = '';
    })
    this.onVerifyAadhar();
    clearInterval(this.interval)


    this.resendClickTimes++;
  }
  onVerifyAadhar() {
    if (this.aadhaarNo.length !== 12) return
    this.util.cleverTapEventCall(CleverTapConstents.aadhaar_verification_initiated,{
      'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
    this.isHideAadharFields = true;
    const loanId = this.util.loanDetails.loanId;
    // const currentApplicant = this.util.getCache('currentApplicant')
    const currentApplicant = this.currentApplicant.id;
    this.showLoader = true;
    this.util.handleRequests('post', this.util.getUrl('aadhar_otp', [loanId, currentApplicant]), {
      "aadhaarNo": this.aadhaarNo,
      "consent": 'Y'
    },undefined,undefined,undefined,false).then((responce: any) => {
      this.showLoader =false;
      if (responce.requestId?.length) {
        this.requestId = responce.requestId;
        this.timerRun();
      }
    }).catch((err: any) => {
      this.resendClickTimes += 2;
      this.showLoader =false;
      this.util.cleverTapEventCall(CleverTapConstents.aadhaar_Verification_failed,{
        'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });
    });
  }

  otpSubmit() {
    const OtpValue = Object.values(this.otpForm.value).join('');
    const loanId = this.util.loanDetails.loanId;
    const currentApplicant = this.currentApplicant.id;
    this.otpForm.disable();
    this.util.handleRequests('post', this.util.getUrl('aadhar_verify_otp', [OtpValue, loanId, currentApplicant]), {
      "aadhaarNo": this.aadhaarNo,
      "consent": 'Y',
      'requestId': this.requestId
    },undefined,undefined,undefined).then((responce: any) => {
      if (responce.statusCode == 101) {
        this.aadharStausUpdate();
      }else{
        this.otpForm.enable();
      }
    }).catch(err => {
      this.resendClickTimes += 2;

      this.otpForm.enable();
      if (err.status == 406) {
        this.errMsg = err.msg;
      }
      this.util.cleverTapEventCall(CleverTapConstents.aadhaar_Verification_failed,{
        'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });
    });
  }
  aadharStausUpdate() {
    const loanId = this.util.loanDetails.loanId;
    this.util.handleRequests('put', this.util.getUrl('aadhar_status_update', [this.currentApplicant.id]), {
      'loanId': loanId
    },undefined,undefined,undefined).then((responce: any) => {
      this.util.cleverTapEventCall(CleverTapConstents.aadhaar_Verification_completed,{
        'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });
      this.util.getProducts(undefined).then(() => {
        this.aadhaarNo = '';
        this.otpForm.enable();
        this.otpForm.reset();
        this.resendTimer = this.defultTime;
        this.init();
        this.switchTab(false, true);
      })
      // if( this.aadhaarVerified[0] && this.aadhaarVerified[1]){
      //   this.util.getProducts().then(() => {
      //     this.util.navigationHandler();
      //   })
      // }
    }).catch((err) => {
      if (err.status == 406) {
        this.errMsg = err.msg;
      }
    })
  }

  onlyNumber(evt: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt?.which) ? evt?.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  openDigiLocker() {
    const loanId = this.util.loanDetails.loanId;
    const currentApplicant = this.util.getCache('currentApplicant');
    this.util.handleRequests('post', this.util.getUrl('digilocker_generateURL', [loanId, currentApplicant])).then(res => {
      if (res.content.code == 200 && res.status == 'SUCCESS') {
        this.util.cleverTapEventCall(CleverTapConstents.digi_locker_verification_initiated,{
          'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
          'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
        });
        this.openDigiLockerDialog = true;
        this.digiUrlDatas = res.content.model

        this.popupWindow = window.open(this.digiUrlDatas.kycUrl);

        this.util.loaderService.show();
        this.checkIfdigilockerCompleted()


      }
    });

  }

  checkIfdigilockerCompleted() {
   
    setTimeout(() => {
      const loanId = this.util.loanDetails?.loanId;
      const currentApplicant = this.util.getCurrentApplicant;
      this.util.handleRequests('post', this.util.getUrl('digilocker_notify', [loanId, currentApplicant?.id, this.digiUrlDatas?.transactionId]), undefined, undefined, undefined, false, false).then((res: any) => {
        this.popupWindow.close();
        this.util.loaderService.hide();
        // this.util.getProducts().then(() => {
          this.aadharStausUpdate();
    this.util.cleverTapEventCall(CleverTapConstents.digi_locker_verification_completed,{
      'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
        // });
      }).catch((err) => {
        console.log(err.msg.content.message);
        
        // console.log(CleverTapConstents.digi_locker_verification_failed);
        // this.util.cleverTapEventCall(CleverTapConstents.digi_locker_verification_failed,{
        //   'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        //   'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
        // });
        if (this.popupWindow?.closed) {
          this.util.showToaster(err.msg?.content?.message, TosterMsgType.ERROR);
          this.util.loaderService.hide();
        } else {
          this.checkIfdigilockerCompleted();
        }


      });
    }, 3000);
  }

  switchTab(isMainApplicant: boolean, resetOnly:boolean = false) {
    // this.isShowAadhaarApplicant = !isMainApplicant;
     if (resetOnly || isMainApplicant) {
      this.aadhaarNo = '';
      this.otpForm.reset();
      this.errMsg = '';
      this.resendClickTimes = 0;
    }
  }
}
